import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import { PageLink, PageTitle } from '../../../_dashboard/layout/core';
import { PagesListWrapper } from './pages-list/PagesList';
import { useIntl } from 'react-intl';

const PagesPage = () => {
  const intl = useIntl(); 

  const PagesBreadcrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({ id: 'PAGE.BREADCRUMB' }), 
      path: '/apps/pages-management/pages',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='Pages'
          element={
            <>
              <PageTitle breadcrumbs={PagesBreadcrumbs}>
                {intl.formatMessage({ id: 'PAGE.TITLE' })}
              </PageTitle>
              <PagesListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/pages-management/pages' />} />
    </Routes>
  );
};

export default PagesPage;